import { createColumnHelper } from "@tanstack/react-table";
import { formatToCurrency } from "utils/currency";
import { PayStubI } from "views/applications-id-report/utils/PayStub";

const columnHelper = createColumnHelper<PayStubI["deductions"]["totals"][0]>();

export const DeductionColumns = [
  columnHelper.accessor("description" as any, {
    header: "Deduction",
    cell: ({ getValue }) => {
      const data = getValue();
      return <p>{data ? data : "-"}</p>;
    }
  }),
  columnHelper.accessor("current_pay", {
    header: "Current pay",
    cell: ({ getValue }) => {
      const data = getValue();
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return <p>{data ? formatToCurrency(data) : "-"}</p>;
    }
  })
];
